import apiCall from "./apiCall";
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  async create_Pumps(data) {
    let response = await apiCall("fuel_pumps/create", data);
    return response;
  },
  async list_Pumps(data) {
    let response = await apiCall("fuel_pumps/list_fuel_pumps", data);
    return response;
  },
  async update_Pumps(data) {
    let response = await apiCall("fuel_pumps/update_fuel_pump", data);
    return response;
  },
};
